export const SORT_OPTION_HOME_PAGE = {
  label: 'Recommended',
  value: 'homepage',
} as const

export const SORT_OPTION_RECOMMENDED = {
  label: 'Recommended',
  value: 'recommended',
} as const

export const SORT_OPTION_NEWEST = {
  label: 'Latest',
  value: 'newest',
} as const

export const SORT_OPTION_ENDING_SOON = {
  label: 'Ending Soon',
  value: 'endingsoon',
} as const

export const SORT_OPTION_POPULARITY = {
  label: 'Bestseller',
  value: 'popularity',
} as const

export const SORT_OPTION_PRICE_ASC = {
  label: 'Price (Lowest)',
  value: 'price.asc',
} as const

export const SORT_OPTION_PRICE_DESC = {
  label: 'Price (Highest)',
  value: 'price.desc',
} as const

export const SORT_OPTION_DISTANCE = {
  label: 'Distance',
  value: 'distance',
} as const

export const SORT_OPTION_VALUE = {
  label: 'Best Value',
  value: 'value',
} as const

export const SORT_OPTION_CUSTOMER_RATING = {
  label: 'Customer Rating (Highest)',
  value: 'customerRating',
} as const

export const SORT_OPTION_INCLUSIONS = {
  label: 'Most Inclusions',
  value: 'inclusions',
} as const

export type OfferListSortOption = typeof SORT_OPTION_RECOMMENDED
  | typeof SORT_OPTION_HOME_PAGE
  | typeof SORT_OPTION_NEWEST
  | typeof SORT_OPTION_ENDING_SOON
  | typeof SORT_OPTION_POPULARITY
  | typeof SORT_OPTION_PRICE_ASC
  | typeof SORT_OPTION_PRICE_DESC
  | typeof SORT_OPTION_DISTANCE
  | typeof SORT_OPTION_VALUE
  | typeof SORT_OPTION_CUSTOMER_RATING
  | typeof SORT_OPTION_INCLUSIONS

export const frontPageSortByTypes: Array<OfferListSortOption> = [
  SORT_OPTION_RECOMMENDED,
  SORT_OPTION_NEWEST,
  SORT_OPTION_ENDING_SOON,
  // Backend changes needed to make price sort work for front page
  // SORT_OPTION_PRICE_ASC,
  // SORT_OPTION_PRICE_DESC,
]

export const newHomePageSortByTypes: Array<OfferListSortOption> = [
  SORT_OPTION_HOME_PAGE,
  SORT_OPTION_NEWEST,
  SORT_OPTION_ENDING_SOON,
]

export const searchSortByTypes: Array<OfferListSortOption> = [
  SORT_OPTION_RECOMMENDED,
  SORT_OPTION_PRICE_ASC,
  SORT_OPTION_PRICE_DESC,
  SORT_OPTION_VALUE,
  SORT_OPTION_NEWEST,
  SORT_OPTION_INCLUSIONS,
]

export const landmarkSearchSortByTypes: Array<OfferListSortOption> = [
  SORT_OPTION_RECOMMENDED,
  SORT_OPTION_PRICE_ASC,
  SORT_OPTION_PRICE_DESC,
  SORT_OPTION_DISTANCE,
  SORT_OPTION_VALUE,
  SORT_OPTION_NEWEST,
  SORT_OPTION_INCLUSIONS,
]
